import type { StorageDownloadTemplates } from 'common/models';

import generateGUID from './guidGenerator';

export const LOCALSTORAGE_DEVICE_ID_KEY = 'deviceId';
export const LOCALSTORAGE_ACCESS_TOKEN_KEY = 'accessToken';
export const LOCALSTORAGE_REFRESH_TOKEN_KEY = 'refreshToken';
export const LOCALSTORAGE_DELEGATE_ACCESS_TOKEN_KEY = 'delegateAccessToken';
export const LOCALSTORAGE_DELEGATE_REFRESH_TOKEN_KEY = 'delegateRefreshToken';
export const ORIGIN_COMPANY_ID = 'originCompanyId';
export const LOCALSTORAGE_DOWNLOAD_URI_TEMPLATES_KEY = 'downloadUriTemplates';

export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(LOCALSTORAGE_DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = generateGUID();
    localStorage.setItem(LOCALSTORAGE_DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const saveAccessToken = (accessToken: string): void => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN_KEY, accessToken);
};

export const getAccessToken = (): string => {
  return localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN_KEY) || '';
};

export const saveRefreshToken = (refreshToken: string): void => {
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN_KEY, refreshToken);
};

export const getRefreshToken = (): string => {
  return localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN_KEY) || '';
};

export const saveDownloadUriTemplates = (downloadUriTemplates: any) => {
  localStorage.setItem(
    LOCALSTORAGE_DOWNLOAD_URI_TEMPLATES_KEY,
    JSON.stringify(downloadUriTemplates)
  );
};

export const getDownloadUriTemplates = (): StorageDownloadTemplates | undefined => {
  const uriTemplates = localStorage.getItem(LOCALSTORAGE_DOWNLOAD_URI_TEMPLATES_KEY);

  return uriTemplates ? JSON.parse(uriTemplates) : undefined;
};

export const saveCurrentTokensAsDeletage = (companyId?: string): void => {
  localStorage.setItem(LOCALSTORAGE_DELEGATE_ACCESS_TOKEN_KEY, getAccessToken());
  localStorage.setItem(LOCALSTORAGE_DELEGATE_REFRESH_TOKEN_KEY, getRefreshToken());
  companyId && localStorage.setItem(ORIGIN_COMPANY_ID, companyId);
};

export const getDelegateAccessToken = () => {
  return localStorage.getItem(LOCALSTORAGE_DELEGATE_ACCESS_TOKEN_KEY) || '';
};

export const getDelegateRefreshToken = () => {
  return localStorage.getItem(LOCALSTORAGE_DELEGATE_REFRESH_TOKEN_KEY) || '';
};

export const getOriginCompanyId = () => {
  return localStorage.getItem(ORIGIN_COMPANY_ID) || '';
};

export const restoreDelegateTokens = (): void => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN_KEY, getDelegateAccessToken());
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN_KEY, getDelegateRefreshToken());
};

export const deleteDelegateTokens = (): void => {
  localStorage.removeItem(LOCALSTORAGE_DELEGATE_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_DELEGATE_REFRESH_TOKEN_KEY);
  localStorage.removeItem(ORIGIN_COMPANY_ID);
};

export const deleteTokens = (): void => {
  localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_DELEGATE_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_DELEGATE_REFRESH_TOKEN_KEY);
  localStorage.removeItem(LOCALSTORAGE_DOWNLOAD_URI_TEMPLATES_KEY);
};
